import React from 'react';
import HomeCard from '../../SharedComponents/HomeCard';
import RenderingStyling from '../../../lib/RenderingStyling';

const DownloadCards = ({ fields, rendering }) => (
  <HomeCard {...RenderingStyling(rendering.componentName)} fields={fields} />
);

export default DownloadCards;
